import React from "react";
import UserLayout from "../../components/Layout/UserLayout";
import { rhymewritingfold1 } from "../../asserts/images";
import InnerHero from "../../components/InnerHero";
import Section2 from "../../components/Section2";
import CustomCategory from "../../components/CustomCategory";
import SecondCustomBanner from "../../components/SecondCustomBanner";
import FirstCustomBanner from "../../components/FirstCustomBanner";
import PublishBook from "../../components/PublishBook";
import Testimonial from "../../components/Testimonial";
import CustomPublication from "../../components/CustomPublication";
import Faq from "../../components/Faq";
import GetTouch from "../../components/GetTouch";
import { Helmet } from "react-helmet";

const GhostWriter = () => {
  return (
    <>

      <Helmet>
        <meta charSet="utf-8" />
        <title>
            Rhyme Writing Services for Poetry & Books
        </title>
        <meta
          name="description"
          content="Craft memorable rhymes and poetic expressions with professional rhyme writing services."
        />
        <meta name="keywords" content="Rhyme Writing" />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <UserLayout>
        <InnerHero
          innerheroclass="ghostwritingBg rhymewritingbg"
          title="Rhyme Writing That"
          subtitle=" Flows "
          title2="With Rhythm and Meaning"
          para="Every rhyme we craft carries rhythm, feeling, and intent. Each line flows seamlessly, capturing emotion while maintaining musical balance. Our rhyme writing turns simple verses into meaningful expressions that echo long after the words end."
        />

        <Section2
          innerSec2Class="innerbrilliant_mind_section innerpages-sec-2"
          title={`Building Harmony Between  `}
          subtitle="  Thought and Sound "
          // title2="As That!"
          description={`Great rhyme writing isn’t just about matching words, it’s about creating harmony between what’s felt and what’s heard. Every syllable, pause, and rhythm carries intention, giving your words emotional depth and melodic structure. By aligning thought with sound, we turn simple verses into art that moves people. Each rhyme flows naturally, connecting ideas while maintaining musical balance and meaning. This perfect blend ensures that your message isn’t just read, it’s felt. Whether it’s poetic verses, lyrical compositions, or brand anthems, our approach brings together linguistic precision and emotional resonance. The result is writing that sings, thoughtful, rhythmic, and unforgettable, where every word plays its part in the symphony of storytelling. `}
          // subtitle1="How we work?"
          // subtitle1Desc="At Random House Publishers, we pride ourselves on being the conduit through which your imagination flows into the world. Our ghostwriting service is designed to empower authors like you to bring your stories to life, even if you need a little extra support along the way. Here’s how we work for you:"
          // subtitle2="    Tailored Collaborations?"
          // subtitle2Desc="We understand that every author is unique, and so are their needs. That’s why we offer personalized ghostwriting services tailored to your specific vision and requirements. Whether you have a fully fleshed-out plot or just a spark of an idea, our team of experienced ghostwriters will work closely with you to bring your story to fruition."
          // subtitle3="  Expert Guidance"
          // subtitle3Desc="Writing a book can be a daunting task, but you don’t have to go it alone. When you choose Random House Publishers, you gain access to a team of seasoned professionals who are passionate about storytelling. From brainstorming sessions to plot development and character arcs, we’ll be there to guide you every step of the way."
          // subtitle3Desc2="Writing a book can be a daunting task, but you don’t have to go it alone. When you choose Random House Publishers, you gain access to a team of seasoned professionals who are passionate about storytelling. "
          image={rhymewritingfold1}
          imgClass="ghost-img2"
        />

        <CustomCategory className="category_section2" />
        <FirstCustomBanner />
        <PublishBook />
        <Testimonial />
        <SecondCustomBanner />
        <CustomPublication />
        <Faq />
        <GetTouch />
      </UserLayout>
    </>
  );
};

export default GhostWriter;
